export interface StoneGuideKeyFactsProps {
  facts: { label: string; value: string }[];
}

export function StoneGuideKeyFacts({ facts }: StoneGuideKeyFactsProps) {
  if (facts.length === 0) return null;

  return (
    <div className="bg-white border border-stone-200 shadow-sm my-8">
      <div className="divide-y divide-stone-200">
        {facts.map((fact) => (
          <div
            key={fact.label}
            className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 px-6 py-4"
          >
            <dt className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-sans">
              {fact.label}
            </dt>
            <dd className="font-sans text-stone-900 font-medium text-sm md:text-base">
              {fact.value}
            </dd>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StoneGuideKeyFacts;
